var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15295 6.5V3.90741C4.42155 2.82716 5.60339 0.666664 8.18194 0.666664C10.7605 0.666664 11.9423 2.82716 12.2109 3.90741V6.5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 6.25C14.4119 6.25 15.5312 7.36931 15.5312 8.75V14.5C15.5312 15.8807 14.412 17 13.0312 17H3.33301C1.95243 16.9998 0.833008 15.8806 0.833008 14.5V8.75C0.83303 7.3694 1.95244 6.25015 3.33301 6.25H13.0312ZM3.33301 7.25C2.50472 7.25015 1.83303 7.92169 1.83301 8.75V14.5C1.83301 15.3283 2.50471 15.9998 3.33301 16H13.0312C13.8597 16 14.5312 15.3284 14.5312 14.5V8.75C14.5312 7.92159 13.8597 7.25 13.0312 7.25H3.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.7dee6d8d0a5f2edb82d1d9cb0d641720.svg";
export { ForwardRef as ReactComponent };